export default __webpack_public_path__ + "static/assets/4e214906036c351953db0fd70899ffbe.svg";